import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// CONSTANTS
import { LOCATIONS_PARTNER_TV_PAGE } from '@/constants/locations';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import ContentSearch from '@/components/ShowMovies/ContentSearch';

// STYLES
import { Container } from './styles';

const SMImg = getS3ImageUrl('/partner-tv/show-movies-guide.png');
const SMImg2x = getS3ImageUrl('/partner-tv/show-movies-guide-2x.png');

const ShowsAndMovies = () => {
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  const { partner } = useSelector(({ partner: partnerStore }) => ({
    partnerData: partnerStore.data,
  }));

  const textOverwrites = partner?.text_overwrites || {};

  return (
    <Container className="section shows-movies">
      <div className="page-content">
        <Typography
          className="text-bold m-b-10"
          component="h2"
          variant={downXs ? 'h4' : 'h2'}
          align="center"
        >
          {textOverwrites?.tv_shows_movies_title || t('partnerTV.showsMovies.title')}
        </Typography>
        <Typography className="m-b-15" variant="subtitle2" align="center">
          {textOverwrites?.tv_shows_movies_subtitle || t('partnerTV.showsMovies.subtitle')}
        </Typography>
        <div className="shows-movies__search m-b-40">
          <ContentSearch analyticsLocation={LOCATIONS_PARTNER_TV_PAGE} />
        </div>
        <div className="shows-movies__img">
          <img srcSet={`${SMImg2x} 2x`} src={SMImg} alt="shows-movies-guide" />
        </div>
      </div>
    </Container>
  );
};

export default React.memo(ShowsAndMovies);
